let $ = jQuery.noConflict(),
	devMode,
	mobileCheck = false,
	pageTransition,
	pageTransitionEnabled = false,
	resizeCallbacks = [],
	clickOrTouch,
	mobileResizeCallbacks = [],
	smoother;

$(function () {
	new StarterKitMcube();
	// new SmoothScroll();

	// Composants Mobile & Desktop
	new BlockChronology();
	new BlockFaq();
	new BlockFullscreenSlider();
	new BlockWrapSlider();
	new BlockTextCards();
	new BlockListingVideos();
	new Buttons();

	new FilterJobOffers();
	new FilterSelect();
	new FormPane();
	new MobileMenu();
	new Modal();
	new ModalAlert();
	new Navigation();
	new NavInternal();
	new ScrollIndicator();
	new Share();
	new TextHighlight();

	new Investors();
	new DicoChimie();

	if (mobileCheck.isMobile) {
		// Composants Mobile uniquement
	} else {
	}
});
